var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('other-components-header'),_c(_vm.cp,{tag:"componets",staticClass:"mainCp",on:{"cpSearch":_vm.cpSearch}}),_c('div',[_c('footer-in-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }